import { Button, Stack } from '@mui/material';
import { useRef } from 'react';
import { createPortal } from 'react-dom';
import { FormattedMessage, useIntl } from 'react-intl';

interface Props {
  onPrevious?: () => void;
  submitLabel?: string;
  disabled?: boolean;
}

export default function Actions({ onPrevious, disabled, submitLabel }: Props) {
  const intl = useIntl();
  const submitRef = useRef<HTMLButtonElement | null>(null);
  const actionsWrapper = document.getElementById('intake-form-actions-wrapper');

  // If submitLabel is not provided, use the default message
  const finalSubmitLabel = submitLabel ?? intl.formatMessage({ defaultMessage: 'Next' });

  const renderActions = () => (
    <Stack direction="row" justifyContent={onPrevious ? 'space-between' : 'flex-end'} alignItems="center">
      {onPrevious ? (
        <Button type="button" variant="contained" color="secondary" onClick={onPrevious} disabled={disabled}>
          <FormattedMessage defaultMessage="Previous" />
        </Button>
      ) : null}
      <Button type="button" onClick={() => submitRef.current?.click()} variant="contained" color="secondary" disabled={disabled}>
        {finalSubmitLabel}
      </Button>
    </Stack>
  );

  return (
    <>
      <button type="submit" ref={submitRef} style={{ display: 'none' }}>
        Submit
      </button>
      {actionsWrapper ? createPortal(renderActions(), actionsWrapper) : renderActions()}
    </>
  );
}
